import React, { useState } from 'react';
import axios from 'axios';
import { API } from "../api";
import { useAuth } from '../App';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(API + '/auth/login', { email, password });
      login(res.data.user, res.data.token, res.data.refreshToken);
      navigate('/');
    } catch (err) {
      setError('Email ou mot de passe incorrect');
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f0efff 0%, #e6f1fb 50%, #f5f5f7 100%)',
    }}>
      {/* Décoration fond */}
      <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
        <div style={{ position: 'absolute', top: -80, right: -80, width: 320, height: 320, borderRadius: '50%', background: 'rgba(124,111,224,0.08)' }} />
        <div style={{ position: 'absolute', bottom: -60, left: -60, width: 240, height: 240, borderRadius: '50%', background: 'rgba(24,95,165,0.06)' }} />
      </div>

      <div style={{
        background: '#fff', borderRadius: 16, padding: '40px 36px',
        width: 340, boxShadow: '0 8px 40px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.06)',
        position: 'relative', zIndex: 1,
        animation: 'fadeInUp 0.4s ease',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 14,
            background: 'linear-gradient(135deg, #7C6FE0, #185FA5)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 26, marginBottom: 12, boxShadow: '0 4px 14px rgba(124,111,224,0.35)',
          }}>📅</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#1a1a2e', letterSpacing: '-0.3px' }}>Congés SWA</div>
          <div style={{ fontSize: 12, color: '#aaa', marginTop: 4 }}>SWA Avocats — Gestion des congés</div>
        </div>

        {error && (
          <div style={{
            background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px',
            borderRadius: 8, marginBottom: 20, fontSize: 13, display: 'flex', alignItems: 'center', gap: 8,
            border: '1px solid #F09595',
          }}>
            <span>⚠️</span> {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 6 }}>Adresse email</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="prenom.nom@swavocats.com"
              autoComplete="email"
              style={{
                width: '100%', padding: '10px 12px', border: '1.5px solid #e0e0e0',
                borderRadius: 8, fontSize: 13, boxSizing: 'border-box',
                transition: 'border-color 0.2s', outline: 'none',
                color: '#333',
              }}
              onFocus={e => e.target.style.borderColor = '#7C6FE0'}
              onBlur={e => e.target.style.borderColor = '#e0e0e0'}
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#555', display: 'block', marginBottom: 6 }}>Mot de passe</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              style={{
                width: '100%', padding: '10px 12px', border: '1.5px solid #e0e0e0',
                borderRadius: 8, fontSize: 13, boxSizing: 'border-box',
                transition: 'border-color 0.2s', outline: 'none',
                color: '#333',
              }}
              onFocus={e => e.target.style.borderColor = '#7C6FE0'}
              onBlur={e => e.target.style.borderColor = '#e0e0e0'}
            />
          </div>
          <button
            type="submit" disabled={loading}
            style={{
              width: '100%', padding: '11px', borderRadius: 9, border: 'none',
              background: loading ? '#bbb' : 'linear-gradient(135deg, #7C6FE0, #185FA5)',
              color: '#fff', fontSize: 14, fontWeight: 600, cursor: loading ? 'default' : 'pointer',
              boxShadow: loading ? 'none' : '0 4px 14px rgba(124,111,224,0.35)',
              transition: 'opacity 0.2s, box-shadow 0.2s',
              letterSpacing: '0.2px',
            }}>
            {loading ? '⏳ Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <button onClick={() => navigate('/forgot-password')}
            style={{
              background: 'none', border: 'none', color: '#7C6FE0', fontSize: 12,
              cursor: 'pointer', fontWeight: 500,
            }}>
            Mot de passe oublié ?
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(16px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default Login;
